// AiWeather is used as a debugging tool against llm-service to run the WeatherWorkflow

import { useState } from 'react';
import {
    BodyMediumRegular,
    H6Regular,
    Input,
    SmoothieScrollView,
    Spinner,
    YStack,
} from 'smoothie';

import { Button } from '../../../../common/components/GroveButtons';
import { GroveSimpleModal } from '../../../../common/components/GroveSimpleModal';
import { useRunWeatherWorkflow } from '../hooks/useRunWeatherWorkflow';

type WeatherRunResult = Awaited<
    ReturnType<ReturnType<typeof useRunWeatherWorkflow>['runWorkflow']>
>;

interface AiWeatherModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const AiWeatherModal = ({ isOpen, onClose }: AiWeatherModalProps) => {
    const [city, setCity] = useState('');
    const [workflowResult, setWorkflowResult] =
        useState<WeatherRunResult | null>(null);

    const { runWorkflow, isPending, isError } = useRunWeatherWorkflow();

    const onPressRunWorkflow = async () => {
        setWorkflowResult(null);

        const result = await runWorkflow({
            inputData: {
                city,
            },
        });

        setWorkflowResult(result);
    };

    return (
        <GroveSimpleModal isOpen={isOpen} onClose={onClose}>
            <YStack width="45vw" height="80vh" padding={16} gap={8}>
                <H6Regular>Weather Workflow</H6Regular>
                <Input
                    value={city}
                    onChangeText={setCity}
                    placeholder="Enter city name"
                />
                <Button
                    variant="secondary"
                    size="small"
                    onPress={onPressRunWorkflow}
                >
                    Run Weather Workflow
                </Button>
                {isPending ? <Spinner /> : null}
                {isError ? (
                    <BodyMediumRegular color="$red1100">
                        Error running WeatherWorkflow.
                    </BodyMediumRegular>
                ) : null}
                <BodyMediumRegular>
                    Status: {workflowResult?.status ?? 'Not started'}
                </BodyMediumRegular>
                <SmoothieScrollView
                    containerStyle={{
                        width: '100% !important',
                        alignSelf: 'flex-start',
                    }}
                >
                    {workflowResult?.status === 'success' && (
                        <BodyMediumRegular>
                            {/* @ts-expect-error - TODO: Improve typing of workflow result. */}
                            Result: {workflowResult.result.activities ?? ''}
                        </BodyMediumRegular>
                    )}
                    {workflowResult?.status === 'failed' && (
                        <BodyMediumRegular color="$red1100">
                            {workflowResult.error ?? 'Unknown error'}
                        </BodyMediumRegular>
                    )}
                </SmoothieScrollView>
            </YStack>
        </GroveSimpleModal>
    );
};
